import { FC, ReactNode } from 'react';
import IconRefresh from '../../../assets/images/search-buttons/refresh.svg?react';

import './Loading.css';

interface LoadingProps {
  color?: 'white' | 'black';
  height?: number;
  width?: number;
  Icon?: ReactNode;
}

// animate svg simple loader
const Loading: FC<LoadingProps> = ({ color = 'white', Icon, height = 30, width = 30 }) => {
  return (
    <div
      style={{
        height,
        width,
        position: 'relative'
      }}
      className={`loading ${color}`}
    >
      {Icon ? Icon : <IconRefresh />}
    </div>
  );
};

export default Loading;
